/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strava_Not_ConnectedInputs */

const en_us2_strava_not_connected = /** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strava was disconnected. Connect it again in Profile.`)
};

const pt_br2_strava_not_connected = /** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava foi desconectado. Conecte de novo no Perfil.`)
};

const pt_pt2_strava_not_connected = /** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava foi desconectado. Conecte de novo no Perfil.`)
};

/** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */
const es_419_strava_not_connected = en_us2_strava_not_connected;

/** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */
const fr_fr2_strava_not_connected = en_us2_strava_not_connected;

/** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */
const de_de2_strava_not_connected = en_us2_strava_not_connected;

/** @type {(inputs: Strava_Not_ConnectedInputs) => LocalizedString} */
const it_it2_strava_not_connected = en_us2_strava_not_connected;

/**
* | output |
* | --- |
* | "Strava was disconnected. Connect it again in Profile." |
*
* @param {Strava_Not_ConnectedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const strava_not_connected = /** @type {((inputs?: Strava_Not_ConnectedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strava_Not_ConnectedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_strava_not_connected(inputs)
	if (locale === "es-419") return es_419_strava_not_connected(inputs)
	if (locale === "pt-PT") return pt_pt2_strava_not_connected(inputs)
	if (locale === "fr-FR") return fr_fr2_strava_not_connected(inputs)
	if (locale === "de-DE") return de_de2_strava_not_connected(inputs)
	if (locale === "it-IT") return it_it2_strava_not_connected(inputs)
	return en_us2_strava_not_connected(inputs)
});
export { strava_not_connected as "strava.not_connected" }